import { createContext } from 'react';

export const CountryContext = createContext<string>('USA');
